<template>
	<div ref="infoForm" class="info-form-cls" v-resize="redraw">
		<section class="header-cls">
			<span class="title-cls">客户信息</span>
			<i class="expand-cls el-icon-d-arrow-right" @click.stop="isCustomerExpand = !isCustomerExpand" :class="isCustomerExpand ? 'bottom' : ''"></i>
			<el-button v-show="isCustomerExpand" @click.stop="handleSave" :loading="loading" type="primary" size="mini" :disabled="$route.query.type == 'details'">保 存</el-button>
		</section>
		<el-collapse-transition>
			<section class="context-cls" v-show="isCustomerExpand">
				<el-form labelPosition="top" autoComplete="on" :model="customerForm" ref="customerForm" :inline="true">
					<div class="show-cls">
						<div class="cell" :class="{'width': width < 600}">
							<el-form-item prop="lastName" label="客户姓：" :rules="[
								{required: $$(columnList, [0], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'}
							]">
								<el-input v-model="customerForm.lastName" maxlength="80" show-word-limit placeholder="请输入" size="small" clearable></el-input>
							</el-form-item>
						</div>
						<div class="cell" :class="{'width': width < 600}">
							<el-form-item prop="firstName" label="客户名：" :rules="[
								{required: $$(columnList, [1], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'}
							]">
								<el-input v-model="customerForm.firstName" maxlength="80" show-word-limit placeholder="请输入" size="small" clearable></el-input>
							</el-form-item>
						</div>
						<div class="cell" :class="{'width': width < 600}">
							<el-form-item prop="phoneNumberDesensitize" label="电话号码：" :rules="[
								{required: $$(columnList, [2], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'}
							]">
								<el-input v-model="customerForm.phoneNumberDesensitize" placeholder="请输入" size="small" clearable style="width: calc(100% - 110px)"></el-input>
								<i @click.stop="handlePhoneAdd" class="icon-cls el-icon-circle-plus-outline"></i>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="外呼" placement="top">
										<svg-icon @click.stop="breathePhone(customerForm.phoneNumberDesensitize, customerForm.phoneNumber)" icon-class="csuPhone1" />
									</el-tooltip>
								</span>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="短信" placement="top">
										<svg-icon @click.stop="breatheSms(customerForm.phoneNumberDesensitize, customerForm.phoneNumber)" icon-class="csuSms1" />
									</el-tooltip>
								</span>
								<!-- <svg-icon @click.stop="breatheVideo(customerForm.phoneNumber)" icon-class="videoSvg" style="margin-left: 9px" /> -->
							</el-form-item>
							<el-form-item prop="phoneNumberDesensitize2" label="" v-if="phoneList.includes(2)" :rules="[
								{required: false, trigger: 'blur', message: '请输入'}
							]">
								<el-input v-model="customerForm.phoneNumberDesensitize2" placeholder="请输入" size="small" clearable style="width: calc(100% - 110px)"></el-input>
								<i @click.stop="handlePhoneDelete(2)" class="icon-cls el-icon-remove-outline"></i>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="外呼" placement="top">
										<svg-icon @click.stop="breathePhone(customerForm.phoneNumberDesensitize2, customerForm.phoneNumber2)" icon-class="csuPhone1" />
									</el-tooltip>
								</span>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="短信" placement="top">
										<svg-icon @click.stop="breatheSms(customerForm.phoneNumberDesensitize2, customerForm.phoneNumber2)" icon-class="csuSms1" />
									</el-tooltip>
								</span>
								<!-- <svg-icon @click.stop="breatheVideo(customerForm.phoneNumber2)" icon-class="videoSvg" style="margin-left: 9px" /> -->
							</el-form-item>
							<el-form-item prop="phoneNumberDesensitize3" label="" v-if="phoneList.includes(3)" :rules="[
								{required: false, trigger: 'blur', message: '请输入'}
							]">
								<el-input v-model="customerForm.phoneNumberDesensitize3" placeholder="请输入" size="small" clearable style="width: calc(100% - 110px)"></el-input>
								<i @click.stop="handlePhoneDelete(3)" class="icon-cls el-icon-remove-outline"></i>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="外呼" placement="top">
										<svg-icon @click.stop="breathePhone(customerForm.phoneNumberDesensitize3, customerForm.phoneNumber3)" icon-class="csuPhone1" />
									</el-tooltip>
								</span>
								<span class="svg-ic">
									<el-tooltip class="item" effect="dark" content="短信" placement="top">
										<svg-icon @click.stop="breatheSms(customerForm.phoneNumberDesensitize3, customerForm.phoneNumber3)" icon-class="csuSms1" />
									</el-tooltip>
								</span>
								<!-- <svg-icon @click.stop="breatheVideo(customerForm.phoneNumber3)" icon-class="videoSvg" style="margin-left: 9px" /> -->
							</el-form-item>
						</div>
						<div class="cell" :class="{'width': width < 600}">
							<el-form-item prop="emailAddress" label="邮箱：" :rules="[
								{required: $$(columnList, [3], 'columnNotNull') === 'Y', trigger: 'blur', message: '请输入'},
								{trigger: 'blur', validator: validateEmail}
							]">
								<el-input v-model="customerForm.emailAddress" placeholder="请输入" size="small" clearable></el-input>
							</el-form-item>
						</div>
					</div>
					
					<el-collapse-transition>
						<div class="hide-cls" v-show="isFormExpand">
							<div class="cell" :class="{'width': width < 600}">
								<el-form-item prop="subBrand" label="子品牌：" :rules="[
									{required: true, trigger: 'blur', message: '请选择'}
								]">
									<el-select v-model="customerForm.subBrand" placeholder="请选择" size="small" filterable clearable>
										<el-option v-for="item in subBrandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="cell" :class="{'width': width < 600}">
								<el-form-item prop="channel" label="所属渠道：" :rules="[
									{required: true, trigger: 'blur', message: '请选择'}
								]">
									<el-select v-model="customerForm.channel" disabled placeholder="请选择" size="small" filterable clearable>
										<el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div class="cell" :class="{'width': ['text', 'file'].includes(item.displayMode) ||  width < 600}" v-for="(item, index) in columnList" :key="index" :style="{'display': index <= 3 ? 'none' : ''}">
								<ComponentLibrary @emitMyCascader="emitMyCascader" @emitWeiXinLy="emitWeiXinLy" :itemData="item" :customerForm="customerForm" />
							</div>
						</div>
					</el-collapse-transition>
					<div @click.stop="isFormExpand = !isFormExpand" class="more-cls">{{isFormExpand ? '收 起' : '更多信息'}}</div>
				</el-form>
			</section>
		</el-collapse-transition>

		<!-- <el-dialog
			title="视频通话"
			 :modal-append-to-body="false"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			width="800px">
			<iframe v-if="dialogVisible" :src="`https://ccaas.ocssaas.com/ocs/video/index.html?roomId=${roomId}`" frameborder="0" width="760px" height="500px"></iframe>
		</el-dialog> -->
		<el-dialog
			title="留言"
			 :modal-append-to-body="false"
			:visible.sync="dialogVisibleWxLy"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			width="600px">
			<sendMsg v-if="dialogVisibleWxLy" style="height: 400px" @onSave="onSave" sourceType="tel"></sendMsg>
		</el-dialog>

		<el-drawer 
			title="发送短信"
            :visible.sync="dialogFormVisible"
            :wrapperClosable="false"
			:modal-append-to-body="false"
			size="600px"
            direction="rtl">
           <Sms v-if="dialogFormVisible" :customerForm="customerForm" :sendPhone="sendPhone" @closeDialogFormVisible="dialogFormVisible = false" />
        </el-drawer>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { validateMobile, validateEmail } from "utils/validator";
import ComponentLibrary from './Library';
import { sipInit } from '../Softphone/jsSipFun';
import sendMsg from '../../views/im-channel/message/details/editor.vue';
import Sms from './Sms';
export default {
	name: "ComponentInfoForm",
	props: ['customerId', 'sourceType'],
	components: {ComponentLibrary, sendMsg, Sms},
	computed: {
        ...mapGetters([
			'userInfo',
			'subBrandList',
			'channelList',
			'StoreAgentInfo', // ~ agent电话相关信息
			'StoreIsSignIn', // ~ 是否签入
			'StoreIsBusy', // ~ 是否置忙
			'StoreIsBusyReason', // ~ 置闲 / 置忙原因
			'StoreIsBusyReasonList',
			'isShowPhone'
        ])
    },
	watch: {
		customerId: {
			handler(val){
				if(val) {
					if(this.sourceType === 'im') return;
					this.getDetailInfo();
				}
			},
			immediate:true,
			deep: true
		},
		isShowPhone: {
			handler(val) {
				this.$set(this.customerForm, 'phoneNumberDesensitize',  val ? this.customerForm['phoneNumber'] : this.hiddenPhone(this.customerForm['phoneNumber']));
				this.$set(this.customerForm, 'phoneNumberDesensitize2',  val ? this.customerForm['phoneNumber2'] : this.hiddenPhone(this.customerForm['phoneNumber2']));
				this.$set(this.customerForm, 'phoneNumberDesensitize3',  val ? this.customerForm['phoneNumber3'] : this.hiddenPhone(this.customerForm['phoneNumber3']));
			}
		}
	},
	data() {
		return {
			dialogFormVisible: false,
			dialogVisible: false,
			dialogVisibleWxLy: false,
			imCustList: [],
			width: 500,
			loading: false,
			validateMobile: validateMobile,
			validateEmail: validateEmail,
			isCustomerExpand: true,
			isFormExpand: false,
			phoneList: [1],
			columnList: [],
			customerForm: {
				lastName: '',
				firstName: '',
				phoneNumberDesensitize: '',
				phoneNumberDesensitize2: '',
				phoneNumberDesensitize3: '',
				phoneNumber: '',
				phoneNumber2: '',
				phoneNumber3: '',
				emailAddress: '',
				subBrand: '',
				channel: ''
			},
			sipDriver: null,
			roomId: '',
			appId: '',
			openId: '',
			isChrome: window.navigator.userAgent.indexOf("Chrome") > -1,
			sendPhone: ''
		}
	},
	mounted() {
		const self = this;
		window.addEventListener('resize', () => {
			if(self.$refs.infoForm) {
				self.width = self.$refs?.infoForm?.clientWidth;
			}
		});
		this.sipDriver = sipInit();
		if(this.sourceType === 'im') this.getDetailInfo();
	},
	methods: {
		redraw(data) {
			this.width = parseInt(data.width);
		},
		onSave(data) {
			if(this.loading) return;
			this.loading = true;
			data['brand'] = this.customerForm.subBrand;
			data['channel'] = this.customerForm.channel;
			data['customerId'] = this.customerForm.customerId;
			this.$api.apiPostSendWeiXinLy(this.appId, this.openId, data).then(response => {
				if(response.errcode != 0) {
					this.loading = false;
					return;
				}
				this.dialogVisibleWxLy = false;
				this.$message.success( '留言成功！');
				this.loading = false;
			});
		},
		emitMyCascader(obj) {
			this.customerForm = Object.assign(this.customerForm, obj);
		},
		emitWeiXinLy(appId, openId) {
			this.appId = appId;
			this.openId = openId;
			this.dialogVisibleWxLy = true;
		},
		// breatheVideo() {
		// 	this.$confirm(`是否发起视频通话？`, '系统提示', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning'
		// 	}).then(() => {
		// 		this.roomId = Math.floor(Math.random() * 1000000);
		// 		this.$api.apiPostSendDX({
		// 			br: "majorel_demo",
		// 			sp: "玫珂菲",
		// 			dc: this.customerForm.customerId,
		// 			dn: '客户名称',
		// 			da: this.customerForm.phoneNumber,
		// 			sm: `坐席-${this.userInfo.nickname}向您发起视频请求，请访问此链接进行视频https://ccaas.ocssaas.com/ocs/video/index.html?roomId=${this.roomId}`,
		// 			sd: '',
		// 			temp: ''
		// 		}).then(response => {
		// 			if(response.errcode != 0) {
		// 				return;
		// 			}
		// 			this.dialogVisible = true;
		// 		});
		// 	}).catch(() => {});
		// },
		breatheSms(phone1, phone2) {
			console.log(phone1, phone2)
			this.sendPhone = (phone1.indexOf("**") != -1) ? phone2 : phone1;
			this.dialogFormVisible = true;
		},
		breathePhone(phone1, phone2) {
			if(!this.isChrome) {
				this.$message.error('仅支持在Chrome浏览器85版本及以上使用');
				return;
			}
			let phone = '';
			phone = (phone1.indexOf("**") != -1) ? phone2 : phone1;
			if(this.StoreIsSignIn && this.StoreIsBusy && this.StoreIsBusyReasonList.includes(this.StoreIsBusyReason) && phone) {
				this.$confirm(`是否向 ${this.isShowPhone ? phone : this.hiddenPhone(phone)} 拨打电话？`, '系统提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if(/^1[3456789]\d{9}$/.test(phone)) {
						this.$api.apiPostSelectForeign({
							phoneNumber: phone,
							landlineNumber: this.$store.getters?.StoreAgentInfo?.calleridText,
						}).then(res => {
							if(res.errcode != 0) {
								this.callModel(phone, true);
							} else {
								if(res.data) {
									this.callModel(phone, true);
								} else {
									this.callModel(phone);
								}
							}
						}).catch(err => {
							this.callModel(phone, true);
						});
					} else {
						this.callModel(phone);
					}
				}).catch(() => {});
			} else {
				this.$message.error('请将软电话设置为置忙 - 外呼');
			}
		},
		callModel(phone, type) {
			if(type) {
				this.$confirm(`外地手机号码前加拨0？`, '系统提示', {
					confirmButtonText: '直接拨打',
					cancelButtonText: '加0拨打',
					type: 'warning',
					distinguishCancelAndClose: true
				}).then(() => {
					this.callFunc(phone);
				}).catch((e) => {
					if(e === 'cancel') {
						this.callFunc('0' + phone);
					}
				});
			} else {
				this.callFunc(phone);
			}
		},
		callFunc(phone) {
			this.$store.commit('telService/SET_IS_CALL', true);
			this.sipDriver._call(phone, {
				brandId: this.userInfo.brandIdentify,
				channelId: 'phone',
				direction: 'OB',
				callingNumber: this.userInfo.deviceCode,
				calledNumber: phone,
				custId: this.customerForm.customerId,
				custName: this.customerForm.firstName + this.customerForm.lastName,
				csrUserId: this.userInfo.userId,
				csrUserName: this.userInfo.account,
				startTime: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
			}, '*5');
		},
		hiddenPhone(phone) {
			if (!phone) return ''
			return phone.substr(0, 3) + '****' + phone.substr(phone.length - 4);
		},
		getDetailInfo() {
			let self = this;
			self.$api.apiQueryTabColumn({brand: self.userInfo.brandIdentify}).then(response => {
				if(response.errcode != 0) return;
				let keyArrayList = [];
				self.columnList = response.data;
				for(let item of self.columnList) {
					// const optionsJson = JSON.parse(item.optionsJson);
					// if(item.displayMode === 'checkbox') {
					// 	let columnNotNull = [];
					// 	for(const _item of optionsJson['data']) {
					// 		if(_item.columnNotNull === 'Y') {
					// 			columnNotNull.push(_item.value);
					// 		}
					// 	}
					// 	self.$set(self.customerForm, item.columnKey, columnNotNull);
						
					// } else if(['droplist', 'radio'].includes(item.displayMode)) {
					// 	let columnNotNull = null;
					// 	for(const _item of optionsJson['data']) {
					// 		if(_item.columnNotNull === 'Y') {
					// 			columnNotNull = _item;
					// 		}
					// 	}
					// 	self.$set(self.customerForm, item.columnKey, columnNotNull ? columnNotNull.value : '');
					// } else {
					// 	self.$set(self.customerForm, item.columnKey, '');
					// }
					if(item.displayMode === 'checkbox') {
						self.$set(self.customerForm, item.columnKey, []);
					} else {
						self.$set(self.customerForm, item.columnKey, '');
					}
					if(item.displayMode === 'checkbox' || item.displayMode === 'cascade') {
						keyArrayList.push(item.columnKey);
					}
				}
				self.$api.apiPostCustomerInfo({brand: self.userInfo.brandIdentify, customerId: self.customerId}).then(res => {
					if(res.errcode != 0) return;
					self.customerForm = Object.assign(self.customerForm, res.data?.[0], res.data?.[0]?.['extendData']);
					Object.keys(self.customerForm).forEach((key) => {
						if(keyArrayList.includes(key)) {
							if(!Array.isArray(self.customerForm[key])) {
								self.customerForm[key] = self.customerForm[key] ? self.customerForm[key].split(',') : [];
							}
						} else if([undefined, null].indexOf(self.customerForm[key]) > -1) {
							self.customerForm[key] = '';
						}
						if(self.customerForm['phoneNumber2'] && !self.phoneList.includes(2)) {
							self.phoneList.push(2);
						} else {
							self.phoneList.splice(2, 1);
						}
						if(self.customerForm['phoneNumber3'] && !self.phoneList.includes(3)) {
							self.phoneList.push(3);
						} else {
							self.phoneList.splice(3, 1);
						}
					});
					self.customerForm['phoneNumberDesensitize'] = self.isShowPhone ? self.customerForm['phoneNumber'] : self.hiddenPhone(self.customerForm['phoneNumber']);
					self.customerForm['phoneNumberDesensitize2'] = self.isShowPhone ? self.customerForm['phoneNumber2'] : self.hiddenPhone(self.customerForm['phoneNumber2']);
					self.customerForm['phoneNumberDesensitize3'] = self.isShowPhone ? self.customerForm['phoneNumber3'] : self.hiddenPhone(self.customerForm['phoneNumber3']);
				});
			});
		},
		handleSave() {
			this.$refs["customerForm"].validate(valid => {
                if (valid) {
					this.loading = true;
					this.customerForm['brand'] = this.userInfo.brandIdentify;
					if(!this.phoneList.includes(2)) {
						this.customerForm['phoneNumber2'] = '';
					}
					if(!this.phoneList.includes(3)) {
						this.customerForm['phoneNumber3'] = '';
					}

                    this.$api.apiUpdateCustomer(this.customerForm).then(response => {
						if(response.errcode != 0) {
							this.loading = false;
							return;
						}
						this.$notify({
							title: '保存成功',
							type: 'success'
						});
						this.getDetailInfo();
						this.loading = false;
					});
                } else {
					this.isFormExpand = true;
				}
            });
			
		},
		handlePhoneAdd() {
			if(this.phoneList.length === 3) {
				return;
			}
			this.phoneList.push(this.phoneList.includes(2) ? 3 : 2);
		},
		handlePhoneDelete(i) {
			this.phoneList.splice(this.phoneList.indexOf(i), 1);
		}
	}
}
</script>

<style lang="scss" scoped>
.info-form-cls {
	width: 100%;

	& > .header-cls {
		width: 100%;
		height: 55px;
		box-sizing: border-box;
		border-bottom: 1px solid #D8D8D8;
		padding: 13.5px 10px;
		box-sizing: border-box;

		& > .title-cls {
			font-size: 14px;
			color: #3C4353;
			line-height: 28px;
			font-weight: bold;
			vertical-align: top;
			user-select:none;
		}

		& > .el-button {
			float: right;
		}

		& > .expand-cls {
			// float: right;
			width: 28px;
			height: 28px;
			line-height: 28px;
			text-align: center;
			cursor: pointer;
			font-weight: 900;
			color: #606266;

			&.bottom {
				transform: rotate(90deg) ;
			}
		}
	}

	& > .context-cls {
		width: 100%;
		padding-bottom: 20px;
		box-sizing: border-box;

		& .cell {
			display: inline-block;
			width: 50%;
			padding: 0 10px;
			box-sizing: border-box;
			vertical-align: top;

			&.width {
				width: 100%;
			}

			::v-deep .el-form-item {
				width: 100%;
				& > .el-form-item__label {
					padding: 0;
					line-height: 30px;
					white-space: nowrap;
					overflow: hidden;
					text-overflow: ellipsis;
				}

				& .el-form-item__content {
					& .el-input, & .el-select, & .el-date-picker, & .el-input-number, & .el-cascader {
						vertical-align: top;
						display: inline-block;
						width: 100%;
					}

					& .el-input-number {
						margin-top: 2px;
					}

					& .el-upload, & .el-upload-dragger {
						width: 100%;
					}

					& .icon-cls {
						vertical-align: top;
						display: inline-block;
						font-size: 16px;
						margin: 0 12px;
						cursor: pointer;
						color: #000000;
						position: relative;
						top: 11px;
					}

					& .svg-ic {
						vertical-align: top;
						display: inline-block;
						width: 28px;
						height: 28px;
						cursor: pointer;
						position: relative;
						top: 4px;
						background: #f3f7ff;
						border-radius: 4px;
						margin-left: 10px;
						line-height: 28px;
						text-align: center;
						padding: 6px;
						box-sizing: border-box;

						&:nth-of-type(1) {
							margin-left: 0;
						}

						& .svg-icon {
							width: 16px;
							height: 16px;
							display: block;
							margin: 0;
							padding: 0;
							text-align: center;
							color: #1890ff;
						}
					}
					
					& .el-radio-group {
						line-height: 48px;
					}
				}
			}
		}

		& .more-cls {
			margin: 0 auto;
			width: 126px;
			height: 24px;
			background: #F6F7F9;
			border-radius: 4px;
			font-size: 12px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #6C7E91;
			line-height: 24px;
			text-align: center;
			cursor: pointer;
		}

		
		

	}
}
</style>
